import type { FaireProductEntity } from "../../entity_types/product";

export const p_ssdpc949sz: FaireProductEntity = {
  token: "p_ssdpc949sz",
  type: "product",
  name: "California Poppy Embroidered Unisex Cotton Pocket Tee",
  brandToken: "b_9ha1ebi2",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/88aa73c16cbf7c64ee86a0c3b3fcc07dfd44ca9cb4d22b82a53c31804eef9cce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/00894f86cdb63cfec183e49488f47b3ecb1b94823f0235460d2c0b52004688fc.jpeg",
    "https://cdn.faire.com/fastly/228b38fd9d1cb4fb1bc91ed7f23709f39546cbda0f657caf27da3e40417fd331.jpeg",
    "https://cdn.faire.com/fastly/b666d5b6d521093fc9f1e4b2d492fa15267250a267c7894d0a2e0018c6cb4277.jpeg",
    "https://cdn.faire.com/fastly/4f34521eee759e0af28265dbff1ff964c0f94bf205b40616ca9d969ee148e45d.jpeg",
    "https://cdn.faire.com/fastly/42706cc08d5e8c9b036924c1503ae2eb0524c98985c442a97f45817b27620260.jpeg",
    "https://cdn.faire.com/fastly/e5496a5c1b05a19c23f9656633da223a73b5626c076364bcd561d78143032e7a.jpeg",
    "https://cdn.faire.com/fastly/a5dec758d41f24573c705081981150eaec1c9fdd4093830930850048158115c7.jpeg",
    "https://cdn.faire.com/fastly/a1dbe960b17969fccfbd418fcd4b05e288ca37796ae45d91a9de009358ba98e4.jpeg",
    "https://cdn.faire.com/fastly/0392d78723334010382a27be80b5018866bce8092e00bc405adef49fa4175be6.jpeg",
    "https://cdn.faire.com/fastly/03222cd3f8885286cc84c113cb42e6ffbafc4c83f75516cf5701a5fa48f4af1d.png",
    "https://cdn.faire.com/fastly/c8d18067f11770a4a565313f6f7ac9145b93780c9dd09b24b421e1463fd34ea0.jpeg",
  ],
  priceDollars: 26.33,
  description:
    "UNISEX EMBROIDERED COTTON POCKET TEE\n\nThese 100% cotton embroidered California Poppy pocket tees are all you need for comfort with a touch of artistic pop. I hand drew each California Poppy and these are embroidered right in the back of the shop.  I have been on the search for the perfect cotton pocket tees for this design and found them. These shirts are incredible fit and the sustainably USA grown cotton feel makes these your new favorite shirt.\n\nEmbroidered at the shop!\n100% Cotton\nSustainably Grown USA Cotton\nOriginal Design By Jamai Lowell\n\nUnisex Sizing (size accordingly)\n\nMaterial:\n6.1 oz/ydý, 100% Ring Spun US Cotton\nPreshrunk, soft-washed, garment-dyed fabric\nMade with sustainably and fairly grown USA cotton and sewn with USA cotton thread\nFeature:\nTwill taped shoulder-to-shoulder\nSet-in sleeves\nDouble-needle stitched sleeves and bottom hem\nLeft-chest pocket\nComfort Colors uses 50% less water than traditional pigment dye processes on pigment dye and color blast garments\n \n\n\n\n",
  tags: [],
  msrpDollars: 52.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:31.189Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
